import PubSub from 'pubsub-js'

import { ProfileRequestResponse } from '@f/applications/QuizApp/partials/types'

export const PROFILE_UPDATED_EVENT = 'PROFILE_UPDATED_EVENT'

export interface ProfileUpdatedEvent {
  message: typeof PROFILE_UPDATED_EVENT
  response: ProfileRequestResponse
}

export function publishProfileUpdatedEvent(
  response: ProfileUpdatedEvent['response']
) {
  PubSub.publish(PROFILE_UPDATED_EVENT, response)
}
